const organizations = {
    title: '组织',
    description: '创建和管理你所属的组织。',
    create: '创建组织',
    create_title: '创建新组织',
    name: '组织名称',
    avatar: '组织头像',
    avatar_removed: '组织头像已移除。',
    description_label: '描述',
    empty: '你暂未加入任何组织。',
    pending_invitations: '待处理邀请',
    accept: '接受',
    decline: '拒绝',
    owner: '所有者',
    tabs: {
        overview: '概览',
        members: '成员',
        invitations: '邀请',
        roles: '管理角色',
        branding: '品牌',
        security: '安全',
        jit: '即时预配',
        applications: '共享资源',
        activity: '活动',
        deletion: '删除',
    },
    members: {
        title: '成员',
        empty: '暂无成员。',
        remove: '移除',
        removed: '成员已移除。',
        business_roles: '业务角色',
        no_business_roles: '暂无可用的业务角色，请联系租户管理员为此组织开放角色。',
    },
    invitations: {
        title: '邀请',
        invite: '邀请成员',
        email: '邮箱地址',
        empty: '暂无邀请。',
        resend: '重新发送',
        resent: '邀请已重新发送。',
        revoke: '撤销',
        revoked: '邀请已撤销。',
        status: {
            Pending: '待接受',
            Accepted: '已接受',
            Expired: '已过期',
            Revoked: '已撤销',
            Declined: '已拒绝',
        },
    },
    roles: {
        title: '管理角色',
        create: '创建角色',
        permissions: '权限',
        empty: '暂无管理角色。',
        select_member: '选择成员',
        select_role: '选择角色',
        assign: '分配角色',
        assigned: '角色已分配。',
        unassign: '移除角色',
        unassigned: '角色已移除。',
        permission_count: '权限数：{{count}}',
        built_in: {
            owner: '所有者',
            owner_description: '拥有组织所有权管理和删除组织的专属权限。',
            administrator: '管理员',
            administrator_description: '可管理组织，但不包括仅限所有者的操作。',
        },
        permission_labels: {
            update_profile: '更新组织资料',
            manage_branding: '管理品牌',
            view_members: '查看成员',
            manage_members: '管理成员',
            manage_invitations: '管理邀请',
            assign_business_roles: '分配业务角色',
            manage_management_roles: '配置管理角色',
            assign_management_roles: '分配管理角色',
            manage_security: '管理安全设置',
            manage_jit: '管理即时预配',
            manage_applications: '管理应用',
            view_activity: '查看活动',
        },
    },
    branding: {
        title: '组织品牌',
        primary_color: '主色',
        custom_css: '自定义层叠样式表（CSS）',
        preview: '预览',
        light: '亮色',
        dark: '暗色',
    },
    security: {
        title: '组织安全',
        require_mfa: '要求成员使用多因素认证',
    },
    jit: {
        title: '即时预配邮箱域名',
        domain: '邮箱域名',
        add: '添加域名',
        verify: '检查域名系统（DNS）',
        dns_instruction: '创建 TXT 文本记录 {{record}}，值为 {{value}}。',
        verified: '已验证',
    },
    applications: {
        title: '共享资源',
        empty: '该组织暂无可用资源。',
        sso: '企业单点登录连接',
        m2m: '机器对机器应用',
    },
    activity: {
        title: '组织活动',
        empty: '暂无活动。',
        events: {
            create: '创建组织',
            delete: '删除组织',
            profile: '更新组织资料',
            branding: '更新组织品牌',
            security: '更新组织安全设置',
            member_add: '添加成员',
            member_remove: '移除成员',
            owner: '变更组织所有者',
            role_create: '创建管理角色',
            role_update: '更新管理角色',
            role_delete: '删除管理角色',
            role_assign: '分配管理角色',
            role_unassign: '移除成员的管理角色',
            business_role: '更新业务角色',
            invitation_create: '发送邀请',
            invitation_accept: '接受邀请',
            invitation_decline: '拒绝邀请',
            invitation_revoke: '撤销邀请',
            jit: '更新即时预配设置',
            domain: '验证邮箱域名',
            application: '更新应用关联',
            unknown: '组织活动',
        },
    },
    save: '保存更改',
    cancel: '取消',
    delete: '删除组织',
    delete_confirmation: '此操作会永久删除组织及其成员关系。请输入“{{name}}”确认。',
    deleted: '组织已删除。',
    load_failed: '无法加载组织数据，请重试。',
    permission_denied: '你没有权限查看此页面。',
};
export default organizations;
